<template>
  <div class="archives-log">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート / {{ year }} 年 / 作業ログ</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-area">
      <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
    </div>
    <div class="section">
      <div class="container" v-if="displayDataCreated">
        <table class="stripe">
          <tr>
            <th class="no">#</th>
            <th class="log-type">操作</th>
            <th class="date">作業実施日</th>
            <th class="worker">作業実施者</th>
            <th class="item">作業項目</th>
            <th class="paddy">ほ場</th>
            <th class="area">計面積(a)</th>
            <th class="path">画像</th>
          </tr>
          <tr
            v-for="(row, index) in logList"
            :key="index"
            class="tr-datas"
            @click="showRefLogFrame(index)"
          >
            <td style="text-align: center">{{ index + 1 }}</td>
            <td style="text-align: center">{{ getDisplayType(row.type) }}</td>
            <td style="text-align: center">{{ formatDatetime(row.work_date, 'YYYY/MM/DD') }}</td>
            <td>{{ row.worker }}</td>
            <td>{{ row.item_name }}</td>
            <td>{{ getDisplayPaddyFields(row.paddy_fields) }}</td>
            <td style="text-align: right">{{ row.area_total }}</td>
            <template v-if="row.image_paths && row.image_paths.length > 0">
              <td class="image-cell">
                <div class="ic-images" />
              </td>
            </template>
            <template v-else>
              <td/>
            </template>
          </tr>
          <tr v-if="logList.length < masterLogList.length">
            <td colspan="8" class="list-message" @click="onClickAllItem">
              <span> すべてを見る </span>
            </td>
          </tr>
          <tr v-if="masterLogList.length === 0">
            <td colspan="8" class="no-message">
              <span> 登録されてるデータがありません </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      v-if="showCenterFrame"
      class="center-frame-container"
    >
      <transition name="scale" appear>
        <div class="center-frame">
          <div class="title-area">
            <h3>作業ログ</h3>
            <div class="btn-close" @click="hideCenterFrame"></div>
          </div>
          <section class="center-frame-section">
            <div class="container">
              <div class="contents-body">
                <table>
                  <tr>
                    <td>
                      <span
                        >{{
                          formatDatetime(logInfo.work_date, "YYYY/MM/DD")
                        }}
                        &nbsp; {{ logInfo.worker }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        >{{ logInfo.season_name }}／{{
                          logInfo.item_name
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr v-if="logInfo.area_total">
                    <td>
                      <span>{{ logInfo.area_total }}&nbsp;(a)</span>
                    </td>
                  </tr>
                </table>
                <div
                  class="detail-list-container"
                  v-if="
                    logInfo.paddy_fields && logInfo.paddy_fields.length > 0
                  "
                >
                  <template v-if="logInfo.paddy_fields.length === 1">
                    <span>{{
                      logInfo.paddy_fields[0].paddy_field_name
                    }}</span>
                  </template>
                  <template v-else>
                    <table>
                      <tr
                        v-for="(row, index) in logInfo.paddy_fields"
                        :key="index"
                      >
                        <td class="tx-no">{{ index + 1 }}</td>
                        <td class="tx-name">{{ row.paddy_field_name }}</td>
                      </tr>
                    </table>
                  </template>
                </div>
                <div
                  class="detail-item-list-container"
                  v-if="
                    logInfo.item_details && logInfo.item_details.length > 0
                  "
                >
                  <template v-for="(row, index) in logInfo.item_details">
                    <template v-if="row.item_detail_value != null">
                      <div :key="index">
                        <span v-if="row.item_detail_unit">
                          {{ row.item_detail_name }}({{
                            row.item_detail_unit
                          }})&ensp;{{ row.item_detail_value }}
                        </span>
                        <span v-else>
                          {{ row.item_detail_name }}&ensp;{{
                            row.item_detail_value
                          }}
                        </span>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="image-area-view">
                  <template v-for="(row, index) in logInfo.image_urls">
                    <div :key="index">
                      <img :src="row" />
                    </div>
                  </template>
                </div>
              </div>
              <div class="contents-footer"></div>
            </div>
          </section>
          <div id="button-area">
            <div class="left-box" />
            <div class="center-box" />
            <div class="right-box" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import XLSX from "xlsx";
import { Storage } from "aws-amplify";

const LIST_COUNT = 10;

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      year: null,
      displayDataCreated: false,
      logList: [],
      logInfo: null,
      masterLogList: [],
      showCenterFrame: false,
    };
  },

  computed: {
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      try {
        await this.searchLogs();
        this.year = await this.getCurrentYear();
      } catch (error) {
        console.log(error);
        alert(error);
      }
    });
  },

  methods: {
    ...mapActions(["retrieveAllLogs"]),
    ...mapGetters(["getCurrentYear"]),

    async searchLogs() {
      this.logList = [];
      try {
        const result = await this.retrieveAllLogs();
        this.masterLogList = result.list;
        this.logList = this.logList.concat(
          this.masterLogList.slice(0, LIST_COUNT)
        );
      } catch (error) {
        console.log(error);
      }
      this.displayDataCreated = true;
    },

    excelDownload() {
      var ws_data = [
        [
          "#",
          "操作",
          "作業実施日",
          "作業実施者",
          "作業分類",
          "作業項目",
          "記録内容",
          "ほ場",
          "計面積(a)",
          "画像",
        ],
      ];
      for (let i = 0; i < this.masterLogList.length; i++) {
        const item = this.masterLogList[i];
        let rowValue = [];
        rowValue.push(i + 1);
        rowValue.push(this.getDisplayType(item.type));
        rowValue.push(this.formatDatetime(item.work_date, 'YYYY/MM/DD'));
        rowValue.push(item.worker);
        rowValue.push(item.season_name);
        rowValue.push(item.item_name);
        rowValue.push(this.getDisplayItemDetails(item.item_details));
        rowValue.push(this.getDisplayPaddyFields(item.paddy_fields));
        rowValue.push(item.area_total);
        rowValue.push(this.getDisplayImages(item.image_paths));
        ws_data.push(rowValue);
      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      // 計面積を数値へ
      for (let row = 1; row <= this.masterLogList.length; row++) {
        var add = XLSX.utils.encode_cell({ r: row, c:8 });
        var cell = ws[add];
        if (cell) {
          // 数値
          cell.t = 'n';
        }
      }

      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_worklog_" +
        this.formatDatetime(dt, 'YYYYMMDDHHmmss') +
        ".xlsx";
      link.click();
    },

    onClickAllItem() {
      this.logList = this.logList.concat(
        this.masterLogList.slice(LIST_COUNT)
      );
    },

    formatDatetime(src, format = "MM/DD HH:mm") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      return dest;
    },
    
    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    getDisplayType(logType) {
      if (logType === 1) {
        return "登録";
      } 
      else if (logType === 2) {
        return "編集";
      }
      else if (logType === 3) {
        return "削除";
      }
      return "";
    },

    getDisplayPaddyFields(paddyFields) {
      var result = "";
      if (paddyFields) {
        for (let i = 0; i < paddyFields.length; i++) {
          if (paddyFields[i].paddy_field_name) {
            if (result.length > 0) {
              result = result.concat(",");
            }
            result = result.concat(paddyFields[i].paddy_field_name);
          }
        }
      }
      return result;
    },

    getDisplayItemDetails(items) {
      var result = "";
      if (items) {
        for (let i = 0; i < items.length; i++) {
          if (result.length > 0) {
            result = result.concat(",");
          }
          result = result.concat(items[i].item_detail_name + ":");
          if (items[i].item_detail_unit) {
            result = result.concat("(" + items[i].item_detail_unit + ")");
          }
          if (items[i].item_detail_value != null) {
            result = result.concat(items[i].item_detail_value);
          }
        }
      }
      return result;
    },

    getDisplayImages(imagePaths) {
      if (imagePaths) {
        return imagePaths.length > 0 ? "有": "";
      }
      return "";
    },
    async showRefLogFrame(index) {
      this.logInfo = this.logList[index];
      this.logInfo.image_urls = [];
      if (this.logInfo.image_paths) {
        try {
          for (const path of this.logInfo.image_paths) {
            const url = await Storage.get(path);
            this.logInfo.image_urls.push(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      this.showCenterFrame = true;
    },
    hideCenterFrame() {
      this.showCenterFrame = false;
    },
  },
};
</script>

<style lang="scss">
.archives-log {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
//    height: calc(100% - 130px);
    max-height: calc(100vh - 200px);
//    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      padding-right: 10px;
      padding-bottom: 10px;

      table {
        //    margin: 30px auto 30px;
        width: 100%;
        border: solid 1px #ddd;
        font-size: 0.9rem;
        background: #fff;
        table-layout: fixed;
        /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
      }
      th {
        padding: 8px;
        border-bottom: solid 1px #bbb;
        border-right: solid 1px #bbb;
        background: #ccc;
        font-weight: normal;
        &.no {
          width: 5%;
          text-align: center;
        }
        &.log-type {
          width: 5%;
        }
        &.date {
          width: 10%;
        }
        &.worker {
          width: 15%;
        }
        &.season {
          width: 10%;
        }
        &.item {
          width: 15%;
        }
        &.detail {
          width: 10%;
        }
        &.paddy {
          width: 20%;
        }
        &.paddy-count {
          width: 10%;
        }
        &.area {
          width: 10%;
        }
        &.path {
          width: 5%;
        }
      }

      th:nth-child(0) {
        border-right: none;
      }

      .tr-datas {
        cursor: pointer;
      }

      td {
        padding: 8px;
        border-bottom: solid 1px #ddd;
        border-right: solid 1px #ddd;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      td:nth-child(0) {
        border-right: none;
      }

      .stripe tr:nth-child(2n + 1) {
        background: #f7f7f7;
      }

      .list-message {
        text-align: center;
        cursor: pointer;

        span {
          color: var(--col3);
        }
      }
      .no-message {
        text-align: center;

        span {
          color: #555;
        }
      }
      .image-cell {
        text-align: center;
        cursor: pointer;
      }

    }
  }

  .button-area {
    height: calc(100% - 130px);
    position: relative;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 20px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }
  .ic-images {
    background: url("~@/assets/icons/ic_photo_active.svg") no-repeat center
      center;
    height: 20px;
    width: 20px;
    display: block;
    margin: auto;
  }

  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      // position: absolute;
      position: fixed;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;
    }

    .title-area {
      width: 100%;
      // height: 80px;
      min-height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }
    .center-frame-section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        .contents-body {
          margin: 10px;

          &.scroll {
            max-height: 50vh;
            overflow-y: scroll;
          }

          span.textarea {
            white-space: pre-line;
          }

          dl.columns {
            width: 100%;
            display: grid;
            grid-template-columns: 180px 1fr;
            align-items: top;
            grid-gap: 0px 0px;
            margin: 0;
            padding: 0;
            font-size: 16px;
            color: #333;

            .mobile & {
              grid-template-columns: 1fr 1.5fr;
            }
          }

          .columns dt {
            display: block;
            text-align: right;
            width: 100%;
            margin: 0;
            padding: 16px;
          }

          .columns dd {
            display: block;
            width: 100%;
            border-left: solid 1px #ddd;
            margin: 0;
            padding: 16px;
          }
        }

        .contents-footer {
          margin: 10px;
        }
      }
    }
  }
  .image-area-view {
    width: 100%;

    img {
      max-width: 100%;
      margin: 10px 0px;
    }
  }
  .detail-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;

    table {
      width: 100%;
      font-size: 0.9rem;
      background: #fff;
    }
    th {
      padding: 8px;
      border-bottom: solid 1px #bbb;
      background: #ccc;
      font-weight: normal;
    }

    th:nth-child(0) {
      border-right: none;
    }

    td {
      padding: 8px;
      border-bottom: solid 1px #ddd;

      &.tx-no {
        width: 10%;
        text-align: center;
      }

      &.tx-name {
        max-width: 0%;
      }
    }

    td:nth-child(0) {
      border-right: none;
    }

    .stripe tr:nth-child(2n + 1) {
      background: #f7f7f7;
    }
  }
  .detail-item-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;
  }

  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }
}
</style>
